import { Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { combineLatest, EMPTY } from 'rxjs';
import { map } from 'rxjs/operators';

import { SwalService } from '@atmi/core';
import { User, UsersApiService } from '@sim/users';
import {
  BaseTableFilteredComponent,
  TableContextMenu,
  TableField,
  TableFilterType,
  TableSortType,
  UiTableComponent,
} from '@ui/ui.module';

import { Audit, AuditFilter, AuditsFiltersMeta } from '../../models/audit';
import { AuditsApiService } from '../../services/audits-api.service';
import { getRouteFromClassName } from '../../utils';
import { AuditsFiltersComponent } from '../audits-filters/audits-filters.component';

type AuditUser = Audit & { userConcrete?: User };

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-audits',
  styleUrls: ['./audits.component.scss'],
  templateUrl: './audits.component.html',
})
export class AuditsComponent extends BaseTableFilteredComponent<AuditUser, AuditFilter> implements UiTableComponent<AuditUser> {

  readonly MobileFiltersComponent = AuditsFiltersComponent;

  readonly fields: TableField<AuditUser>[] = [
    {
      context: (x) => `${x.userConcrete?.username}`,
      header: this.translate.instant('Username'),
      key: 'userConcrete',
    },
    {
      header: this.translate.instant('Tipo'),
      key: 'type',
    },
    {
      header: this.translate.instant('Oggetto'),
      key: 'className',
    },
    {
      context: (x) => x.date,
      header: this.translate.instant('Data operazione'),
      hideBreakpoints: [Breakpoints.XSmall, Breakpoints.Small],
      key: 'date',
      sortable: true,
      template: 'date-time',
    },
    {
      align: 'right',
      header: '',
      key: 'context',
      showBreakpoints: [Breakpoints.XSmall, Breakpoints.Small],
      template: 'context',
    },
  ];

  readonly pager$ = ((page?: number, limit?: number, sort?: TableSortType, filter?: TableFilterType) => {
    sort = sort && sort.length > 0 ? sort : [{ field: 'date', type: 'desc' }];

    return combineLatest([
      this.auditApi.index({ page, limit, sort, filter }),
      this.userApi.index(),
    ]).pipe(
      map(([auditPage, userPage]) => {
        const users = userPage.data;
        const audits: AuditUser[] = auditPage.data.map((a) => ({
          ...a,
          userConcrete: users.find((u) => u.id === a.user),
        }));
        return { ...auditPage, data: audits };
      }),
    );
  });

  readonly contextMenus: Array<TableContextMenu<Audit>> = [
    {
      action: (item) => this.router.navigate([getRouteFromClassName(item.className, item.objectId)]),
      label: this.translate.instant('Visualizza la risorsa'),
    },
  ];

  constructor(
    private readonly auditApi: AuditsApiService,
    private readonly userApi: UsersApiService,
    protected readonly translate: TranslateService,
    protected readonly router: Router,
    protected readonly route: ActivatedRoute,
    protected readonly swalService: SwalService,
  ) {
    super(translate, router, route, AuditsFiltersMeta, swalService);
  }

  deleteConcreteHandler() {
    return EMPTY;
  }

  deleteSelectedConcreteHandler() {
    return EMPTY;
  }
}
